export default {
  appTitle: 'Provider web',
  title: 'Login',
  registerButton: 'Register',
  consultRecordButton: 'Consult record',
  loginButton: 'Login',
  forgotPasswordButton: 'Forgot my password',
  signIn: {
    button: 'Sign In',
    label: '¿You still don\'t have an account?'
  },
  email: {
    inputLabel: 'Email'
  },
  password: {
    inputLabel: 'Password'
  },
  temporal: {
    title: 'Temporal paperwork',
    description: 'Creation and status consultation of temporary requests to GNP for suppliers without direct payment agreement:',
    newButton: 'New paperwork',
    checkButton: 'Check status'
  }
}
